@if (mode != 'Touch') {
    <div class="d-flex-center preset-animation">
        <!--            <button mat-raised-button color="primary" (click)="previewAnimation();">-->
        <!--                <mat-icon>graphic_eq</mat-icon>-->
        <!--                {{'general.preview' | transloco}}-->
        <!--            </button>-->
        <button mat-raised-button color="primary" (click)="presetAnimation();">
            <mat-icon>developer_board</mat-icon>
            {{'general.preset' | transloco}}
        </button>

        <!-- <div style="opacity: 0.8; margin-left: 15px;" fxLayout="row">
            <span>{{'general.advanced' | transloco}}</span>
            <div style="padding-left: 5px;">
                <mat-slide-toggle [(ngModel)]="animationEditMode"></mat-slide-toggle>
            </div>
        </div> -->
    </div>
    <br/>
    <mat-divider></mat-divider>
}

@if (mode=='In' || mode=='Out') {
    <div>
        <form class="props-layout" [formGroup]="propsGroup">
            <div class="row">
                <span class="col1">{{ "general.delay" | transloco }}</span>
                <div class="col2">
                    <mat-form-field class="animationFieldWidth">
                        <mat-label>{{ "general.seconds" | transloco }}</mat-label>
                        <input
                            inputrestriction="numbers"
                            (change)="onChangeProps('delay')"
                            matInput
                            step="0.1"
                            type="number"
                            min="0"
                            max="60"
                            class="form-control"
                            placeholder="{{ 'general.seconds' | transloco }}"
                            required
                            formControlName="delay"
                        />
                    </mat-form-field>
                    <!--                <mat-slider discrete disableRipple color="accent" [max]="60" [min]="0" [step]="1">-->
                    <!--                    <input matSliderThumb (change)="onChangeProps('delay')" formControlName="delay"/>-->
                    <!--                </mat-slider>-->
                </div>
            </div>
            <div class="row">
                <span class="col1">{{ "general.duration" | transloco }}</span>
                <div class="col2">
                    <mat-form-field style="width: 120px">
                        <mat-label>{{ "general.seconds" | transloco }}</mat-label>
                        <input
                            inputrestriction="numbers"
                            (change)="onChangeProps('duration')"
                            matInput
                            step="0.1"
                            type="number"
                            min="1"
                            max="60"
                            class="form-control"
                            placeholder="{{ 'general.seconds' | transloco }}"
                            required
                            formControlName="duration"
                        />
                    </mat-form-field>
                    <!--                <mat-slider discrete disableRipple color="accent" [max]="60" [min]="1" [step]="1">-->
                    <!--                    <input matSliderThumb (change)="onChangeProps('duration')" formControlName="duration"/>-->
                    <!--                </mat-slider>-->
                </div>
            </div>
            <mat-divider></mat-divider>
            <div class="row">
                <span class="col1">{{ "general.fade" | transloco }}</span>
                <mat-form-field class="col2">
                    <mat-select panelWidth="null" (selectionChange)="onChangeProps('fadeFrq')" formControlName="fadeFrq">
                        <mat-option [value]="'0'">never</mat-option>
                        <mat-option [value]="'0.1'">rarely</mat-option>
                        <mat-option [value]="'0.5'">sometimes</mat-option>
                        <mat-option [value]="'0.75'">often</mat-option>
                        <mat-option [value]="'1'">always</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <mat-divider></mat-divider>
            <div class="row">
                <span class="col1">{{ "general.move" | transloco }}</span>
                <mat-form-field class="col2">
                    <mat-select panelWidth="null" (selectionChange)="onChangeProps('moveFrq')" formControlName="moveFrq">
                        <mat-option [value]="'0'">never</mat-option>
                        <mat-option [value]="'0.1'">rarely</mat-option>
                        <mat-option [value]="'0.5'">sometimes</mat-option>
                        <mat-option [value]="'0.75'">often</mat-option>
                        <mat-option [value]="'1'">always</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="row">
                <span class="col1">{{ "general.intensity" | transloco }}</span>
                <div class="col2">
                    <span class="slider-value">{{ slider1.value }}</span>
                    <mat-slider discrete disableRipple color="accent" [max]="3" [min]="0.1" [step]="0.1">
                        <input #slider1 matSliderThumb (change)="onChangeProps('moveIntense')" formControlName="moveIntense" />
                    </mat-slider>
                </div>
            </div>
            <div class="row">
                <span class="col1">{{ "general.type" | transloco }}</span>
                <mat-form-field class="col2">
                    <mat-select panelWidth="null" (selectionChange)="onChangeProps('moveDir')" formControlName="moveDir">
                        <mat-option [value]="'fixed'">fixed</mat-option>
                        <mat-option [value]="'random'">random</mat-option>
                        @if (mode=='Out') {
                        <mat-option [value]="'revert'">revert</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="row">
                <span class="col1">{{ "general.direction" | transloco }}</span>
                <div class="col2">
                    <app-rotator
                        #appRotator
                        [value]="propsGroup.value.moveAngle"
                        class="appRotator"
                        [step]="5"
                        [showToolTop]="false"
                        [disabled]="(propsGroup.get('moveDir') | formControl).value === 'random' || (propsGroup.get('moveFrq') | formControl).value === '0'"
                        (changed)="onChangeProps('moveAngle', $event)"
                    ></app-rotator>
                </div>
                @if (mode=='In') {
                <div>
                    <mat-icon [ngStyle]="{ transform: 'rotate' + '(' + appRotator.rotated + 'deg' + ')' }" class="directionRotate">start</mat-icon>
                </div>
                } @if (mode=='Out') {
                <div>
                    <mat-icon [ngStyle]="{ transform: 'rotate' + '(' + appRotator.rotated + 'deg' + ')' }" class="directionRotate">keyboard_tab</mat-icon>
                </div>
                }
            </div>
            <mat-divider></mat-divider>
            <div class="row">
                <span class="col1">{{ "general.scale2" | transloco }}</span>
                <mat-form-field class="col2">
                    <mat-select panelWidth="null" (selectionChange)="onChangeProps('scaleFrq')" formControlName="scaleFrq">
                        <mat-option [value]="'0'">never</mat-option>
                        <mat-option [value]="'0.1'">rarely</mat-option>
                        <mat-option [value]="'0.5'">sometimes</mat-option>
                        <mat-option [value]="'0.75'">often</mat-option>
                        <mat-option [value]="'1'">always</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <mat-divider></mat-divider>
            <div class="row">
                <span class="col1">{{ "general.rotate" | transloco }}</span>
                <mat-form-field class="col2">
                    <mat-select panelWidth="null" (selectionChange)="onChangeProps('rotateFrq')" formControlName="rotateFrq">
                        <mat-option [value]="'0'">never</mat-option>
                        <mat-option [value]="'0.1'">rarely</mat-option>
                        <mat-option [value]="'0.5'">sometimes</mat-option>
                        <mat-option [value]="'0.75'">often</mat-option>
                        <mat-option [value]="'1'">always</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="row">
                <span class="col1">{{ "general.type" | transloco }}</span>
                <mat-form-field class="col2">
                    <mat-select panelWidth="null" (selectionChange)="onChangeProps('rotateType')" formControlName="rotateType">
                        <mat-option [value]="'fixed'">fixed</mat-option>
                        <mat-option [value]="'random'">random</mat-option>
                        @if (mode=='Out') {
                        <mat-option [value]="'revert'">revert</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="row">
                <span class="col1">{{ "general.rotations" | transloco }}</span>
                <div class="col2">
                    <span class="slider-value">{{ slider2.value }}</span>
                    <mat-slider discrete disableRipple color="accent" [max]="10" [min]="-10" [step]="2">
                        <input #slider2 matSliderThumb (change)="onChangeProps('rotations')" formControlName="rotations" />
                    </mat-slider>
                </div>
            </div>
            <mat-divider></mat-divider>
            <div class="row">
                <span class="col1">{{ "general.blur" | transloco }}</span>
                <mat-form-field class="col2">
                    <mat-select panelWidth="null" (selectionChange)="onChangeProps('blurFrq')" formControlName="blurFrq">
                        <mat-option [value]="'0'">never</mat-option>
                        <mat-option [value]="'0.1'">rarely</mat-option>
                        <mat-option [value]="'0.5'">sometimes</mat-option>
                        <mat-option [value]="'0.75'">often</mat-option>
                        <mat-option [value]="'1'">always</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="row">
                <span class="col1"></span>
                <div class="col2">
                    <span class="slider-value">{{ slider3.value }}</span>
                    <mat-slider discrete disableRipple color="accent" [max]="20" [min]="1" [step]="1">
                        <input #slider3 matSliderThumb (change)="onChangeProps('blurValue')" formControlName="blurValue" />
                    </mat-slider>
                </div>
            </div>
            <mat-divider></mat-divider>
            <div class="row">
                <span class="col1">{{ "general.typing" | transloco }}</span>
                <mat-form-field class="col2">
                    <mat-select panelWidth="null" (selectionChange)="onChangeProps('textTypingFrq')" formControlName="textTypingFrq">
                        <mat-option [value]="'0'">never</mat-option>
                        <mat-option [value]="'0.1'">rarely</mat-option>
                        <mat-option [value]="'0.5'">sometimes</mat-option>
                        <mat-option [value]="'0.75'">often</mat-option>
                        <mat-option [value]="'1'">always</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </form>
    </div>
}
@else if (mode=='Play') {
    <div>
        <form class="props-layout" [formGroup]="propsGroup">
            <div class="row">
                <span class="col1">{{ "general.duration" | transloco }}</span>
                <div class="col2">
                    <mat-form-field class="animationFieldWidth">
                        <mat-label>{{ "general.seconds" | transloco }}</mat-label>
                        <input
                            inputrestriction="numbers"
                            (change)="onChangeProps('duration')"
                            matInput
                            step="1"
                            type="number"
                            min="0"
                            max="360"
                            class="form-control"
                            placeholder="{{ 'general.seconds' | transloco }}"
                            required
                            formControlName="duration"
                        />
                    </mat-form-field>
                </div>
                <!--            <span class="col1">{{'general.duration' | transloco}}</span>-->
                <!--            <div class="col2">-->
                <!--                <mat-slider discrete disableRipple color="accent" [max]="60" [min]="0.1" [step]="0.1">-->
                <!--                    <input matSliderThumb (change)="onChangeProps('duration')" formControlName="duration"/>-->
                <!--                </mat-slider>-->
                <!--            </div>-->
            </div>
            <div class="row">
                <span class="col1">{{ "general.frequency" | transloco }}</span>
                <div class="col2">
                    <span class="slider-value">{{ slider4.value }}</span>
                    <mat-slider discrete disableRipple color="accent" [max]="60" [min]="0.1" [step]="0.1">
                        <input #slider4 matSliderThumb (change)="onChangeProps('frequency')" formControlName="frequency" />
                    </mat-slider>
                </div>
            </div>
            <div class="row">
                <span class="col1">{{ "general.rotateFrq" | transloco }}</span>
                <mat-form-field class="col2">
                    <mat-select panelWidth="null" (selectionChange)="onChangeProps('rotateFrq')" formControlName="rotateFrq">
                        <mat-option [value]="'0'">never</mat-option>
                        <mat-option [value]="'0.1'">rarely</mat-option>
                        <mat-option [value]="'0.5'">sometimes</mat-option>
                        <mat-option [value]="'0.75'">often</mat-option>
                        <mat-option [value]="'1'">always</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="row">
                <span class="col1">{{ "general.rotateValue" | transloco }}</span>
                <div class="col2">
                    <app-rotator
                        [value]="propsGroup.value.rotateValue"
                        class="appRotator"
                        [step]="5"
                        [showToolTop]="false"
                        [disabled]="(propsGroup.get('rotateFrq') | formControl).value === '0'"
                        (changed)="onChangeProps('moveAngle', $event)"
                    ></app-rotator>
                </div>
            </div>
            <div class="row">
                <span class="col1">{{ "general.fadeFrq" | transloco }}</span>
                <mat-form-field class="col2">
                    <mat-select panelWidth="null" (selectionChange)="onChangeProps('fadeFrq')" formControlName="fadeFrq">
                        <mat-option [value]="'0'">never</mat-option>
                        <mat-option [value]="'0.1'">rarely</mat-option>
                        <mat-option [value]="'0.5'">sometimes</mat-option>
                        <mat-option [value]="'0.75'">often</mat-option>
                        <mat-option [value]="'1'">always</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="row">
                <span class="col1">{{ "general.scaleFrq" | transloco }}</span>
                <mat-form-field class="col2">
                    <mat-select panelWidth="null" (selectionChange)="onChangeProps('scaleFrq')" formControlName="scaleFrq">
                        <mat-option [value]="'0'">never</mat-option>
                        <mat-option [value]="'0.1'">rarely</mat-option>
                        <mat-option [value]="'0.5'">sometimes</mat-option>
                        <mat-option [value]="'0.75'">often</mat-option>
                        <mat-option [value]="'1'">always</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="row">
                <span class="col1">{{ "general.scale2" | transloco }}</span>
                <div class="col2">
                    <span class="slider-value">{{ slider5.value }}</span>
                    <mat-slider discrete disableRipple color="accent" [max]="2" [min]="1.1" [step]="0.1">
                        <input #slider5 matSliderThumb (change)="onChangeProps('scaleValue')" formControlName="scaleValue" />
                    </mat-slider>
                </div>
            </div>
        </form>
    </div>
}
@else if (mode=='Touch') {
    <div>
        <form class="props-layout" [formGroup]="propsGroup">
            <div class="row">
                <span class="col1">{{ "general.duration" | transloco }}</span>
                <div class="col2">
                    <span class="slider-value">{{ slider6.value }}</span>
                    <mat-slider discrete disableRipple color="accent" [max]="1000" [min]="100" [step]="1">
                        <input #slider6 matSliderThumb (change)="onChangeProps('duration')" formControlName="duration" />
                    </mat-slider>
                </div>
            </div>
            <div class="row">
                <span class="col1">{{ "general.scaleValue" | transloco }}</span>
                <div class="col2">
                    <span class="slider-value">{{ slider7.value }}</span>
                    <mat-slider discrete disableRipple color="accent" [max]="2" [min]="1.1" [step]="0.1">
                        <input #slider7 matSliderThumb (change)="onChangeProps('scaleValue')" formControlName="scaleValue" />
                    </mat-slider>
                </div>
            </div>
        </form>
    </div>
}
